import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLayoutLeftFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8 3V21H5C3.94564 21 3.08183 20.1841 3.00549 19.1493L3 19V5C3 3.94564 3.81588 3.08183 4.85074 3.00549L5 3H8ZM19 3C20.0544 3 20.9182 3.81588 20.9945 4.85074L21 5V19C21 20.0544 20.1841 20.9182 19.1493 20.9945L19 21H10V3H19Z" })
});
export default SvgLayoutLeftFill;
